export class LyricsTextMeasurer {
  private static _instance?: LyricsTextMeasurer;
  private _svg: SVGSVGElement;

  private constructor() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    this._svg = document.body.appendChild(svg);
    this._svg.setAttribute('class', 'lyrics-text-measurer');
  }

  public static get instance(): LyricsTextMeasurer {
    if (!LyricsTextMeasurer._instance) {
      LyricsTextMeasurer._instance = new LyricsTextMeasurer();
    }
    return LyricsTextMeasurer._instance;
  }

  public static initiate() {
    LyricsTextMeasurer._instance = new LyricsTextMeasurer();
  }

  public static destroy() {
    document.querySelectorAll('.lyrics-text-measurer').forEach((el) => {
      document.body.removeChild(el);
    });
    LyricsTextMeasurer._instance = undefined;
  }

  public setElement(element: SVGElement) {
    this.clear();
    this._svg.appendChild(element);

    const el = this._svg.firstChild as unknown as SVGTextContentElement;

    return el;
  }

  public clear() {
    while (this._svg.firstChild) {
      this._svg.removeChild(this._svg.firstChild);
    }
  }

  get element(): SVGTextContentElement {
    return this._svg.firstChild as SVGTextContentElement;
  }
}
